import { render, staticRenderFns } from "./allfunc-sheet.vue?vue&type=template&id=a4c2d6f6&scoped=true&"
import script from "./allfunc-sheet.vue?vue&type=script&lang=js&"
export * from "./allfunc-sheet.vue?vue&type=script&lang=js&"
import style0 from "./allfunc-sheet.vue?vue&type=style&index=0&id=a4c2d6f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c2d6f6",
  null
  
)

export default component.exports